import {register} from '@shopify/theme-sections';
import Swiper, { Navigation } from "swiper";

const selectors = {
  target: '.featured-blog--',
};

register('featured-blog-section', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `${selectors.target}${id}`;
    const targetSelector = document.querySelector(target);

    if (!targetSelector) { return; }

    Swiper.use([Navigation]);

    const desktopPostCount = targetSelector.dataset.desktopPostRow;
    const mobilePostCount = targetSelector.dataset.mobilePostRow;
    const swiper = new Swiper(target, {
      slidesPerView: desktopPostCount,
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
        },
        340: {
          slidesPerView: mobilePostCount,
        },
        1020: {
          slidesPerView: desktopPostCount,
        }
      }
    });
  },
});
